import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  user: any;

  constructor(
    public storeManager: AppLocalStorage,
    private router: Router,
  ) { }

  ngOnInit() {
    this.user = this.storeManager.getFromStorage('user');
  }

  closeLogoutModal = () => {
    document.getElementById('logoutModalToggleBtn')?.click();
  }

  logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    this.closeLogoutModal();
    this.router.navigate(['/auth']);
  }

}
